import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["customField"];

  connect() {
    console.log("Custom reason controller connected");
    this.updateCustomFieldVisibility();
  }

  reasonChanged(event) {
    console.log("Reason checkbox changed:", event.target.checked, event.target.dataset.reasonCode);
    this.updateCustomFieldVisibility();
  }

  updateCustomFieldVisibility() {
    const otherReasonCheckbox = this.element.querySelector('input[data-reason-code="other_reason"]');
    const isOtherReasonSelected = otherReasonCheckbox && otherReasonCheckbox.checked;
    
    if (this.hasCustomFieldTarget) {
      if (isOtherReasonSelected) {
        this.customFieldTarget.classList.remove('hidden');
        // Rendre le champ obligatoire
        const textarea = this.customFieldTarget.querySelector('textarea');
        if (textarea) {
          textarea.required = true;
        }
      } else {
        this.customFieldTarget.classList.add('hidden');
        // Supprimer l'obligation
        const textarea = this.customFieldTarget.querySelector('textarea');
        if (textarea) {
          textarea.required = false;
          textarea.value = ''; // Vider le champ si not selected
        }
      }
    }
  }
} 